import React, { useEffect, useState } from 'react'
import ForgotPasswordForm from '../../../components/Auth/ForgotPassword/ForgotPasswordForm'
import Banner from '../../../components/Banner/Banner'
import MainLayout from '../../../components/MainLayout/MainLayout'
import { useLanguage } from '../../../components/LanguageProvider/LanguageProvider '
import { forgotPassword } from '../../../services/api/auth'
import { ClearLocalStorage } from '../../../Utils/Utils'
import { getHomePageContent } from '../../../services/api/outer'
import { getConfigurationData } from '../../../services/api/user'

const ForgotPassword = () => {
  const { language, setLanguage } = useLanguage();

  const [forgetPasswordFormData, setForgetPasswordFormData] = useState([]);
  const [forgetPasswordAllData, setForgetPasswordAllData] = useState();
  const [homePageData, setHomePageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sendMobileOtp, setSendMobileOtp] = useState(false)
  //  Get forget forms fields
  const GetForgetFormField = () => {
   
    forgotPassword().then(res => {
      if (res) {
        const filterOnlyRequiredFields = res?.data?.input_fields?.filter((i) => i?.required !== "0")
        const updatedData = filterOnlyRequiredFields?.map(item => ({
          ...item,
          value: '',
          error: ''  // Set the default value as needed
        }));
        setForgetPasswordFormData(updatedData)
        setForgetPasswordAllData(res?.data)
      }}).catch((error) => { 
    });
    
      /*const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
      },
      url: `${Apiurl()}/forgot-password-form`,
       };*/
    /*axios(option)
      .then((e) => {
        const filterOnlyRequiredFields = e?.data?.data?.input_fields?.filter((i) => i?.required !== "0")
        const updatedData = filterOnlyRequiredFields?.map(item => ({
          ...item,
          value: '',
          error: ''  // Set the default value as needed
        }));
        setForgetPasswordFormData(updatedData)
        setForgetPasswordAllData(e?.data?.data)



      })
      .catch((error) => {

      });*/
  };

  const getConfiguration = async (item) => {
        try {
          const configData = await getConfigurationData();
          const data = configData?.data?.find((x) => x.type == "sms");
          setSendMobileOtp(data?.status == 1 ? true : false)
          setLoading(false);
        } catch (err) {
          setLoading(false);
        }
  };
  
  useEffect(() => {

    window.scrollTo(0, 0);
    const fetchData = async () => {
      try {
        const [homePageDataResponse] = await Promise.all([
          getHomePageContent(),
        ]);
        setHomePageData(homePageDataResponse);
        
      } catch (error) {
        //console.error("Error fetching data", error);
      } finally {
      }
    };

    fetchData();
    ClearLocalStorage();
    GetForgetFormField();
    getConfiguration()
  }, [])
  
  if(loading) {
    return <></>
  }

  return (
    <>
      <MainLayout homePageData={homePageData}>
        <Banner first={language ? "होम" : "Home"} second={language ? "पासवर्ड भूल गए पृष्ठ" : "Forgot Password Page"} head={language ? "पासवर्ड भूल गए" : "Forgot Password"} />
        <ForgotPasswordForm forgetPasswordFormData={forgetPasswordFormData} setForgetPasswordFormData={setForgetPasswordFormData} forgetPasswordAllData={forgetPasswordAllData} hideShowMobileOtp={sendMobileOtp} />
      </MainLayout>
    </>
  )
}

export default ForgotPassword
